
import { useEffect, useState } from 'react';

export default function PrivacyHero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [animated, setAnimated] = useState(false);
  const [kineticIndex, setKineticIndex] = useState(0);

  const backgroundImages = [
    "https://readdy.ai/api/search-image?query=Modern%20data%20center%20server%20room%20with%20rows%20of%20illuminated%20server%20racks%20in%20soft%20teal%20and%20white%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20professional%20technology%20infrastructure%20photography%2C%20bright%20ambient%20glow%2C%20high-end%20corporate%20environment%2C%20pristine%20and%20organized&width=1920&height=1080&seq=privacy-server-001&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20visualization%20with%20flowing%20encrypted%20data%20streams%20and%20geometric%20patterns%20in%20soft%20teal%20and%20white%20colors%2C%20bright%20clean%20aesthetic%2C%20modern%20cybersecurity%20concept%20art%2C%20light%20ethereal%20atmosphere%2C%20premium%20technology%20background%2C%20minimalist%20design&width=1920&height=1080&seq=privacy-security-002&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Futuristic%20cloud%20computing%20infrastructure%20with%20glowing%20network%20connections%20and%20server%20nodes%20in%20bright%20teal%20and%20white%20palette%2C%20clean%20modern%20technology%20visualization%2C%20soft%20ambient%20lighting%2C%20professional%20corporate%20aesthetic%2C%20high-end%20digital%20environment&width=1920&height=1080&seq=privacy-cloud-003&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Secure%20vault%20door%20with%20digital%20encryption%20interface%20in%20modern%20data%20center%2C%20teal%20accent%20lighting%20on%20brushed%20metal%20surfaces%2C%20bright%20clean%20professional%20photography%2C%20high-end%20security%20technology%20concept%2C%20minimalist%20corporate%20aesthetic%2C%20soft%20diffused%20lighting&width=1920&height=1080&seq=privacy-vault-004&orientation=landscape"
  ];

  const kineticWords = ['Secure', 'Encrypted', 'Protected'];

  useEffect(() => {
    setAnimated(true);

    const imageInterval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % backgroundImages.length);
    }, 5000);

    const kineticInterval = setInterval(() => {
      setKineticIndex((prev) => (prev + 1) % kineticWords.length);
    }, 2000);

    return () => {
      clearInterval(imageInterval);
      clearInterval(kineticInterval);
    };
  }, []);

  const features = [
    'AES-256 encryption in transit',
    'Processed in memory only',
    'Deleted immediately after generation',
    'Zero data retention',
    'No third-party access',
    'Nothing to subpoena',
  ];

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Slideshow */}
      <div className="absolute inset-0">
        {backgroundImages.map((img, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-[2000ms] ${
              currentImageIndex === index ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={img}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-[#09090b]/40 via-[#09090b]/25 to-[#09090b]/60"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-8 py-24 sm:py-32">
          <div className="max-w-[800px] mx-auto text-center space-y-6 sm:space-y-8">
            <h1
              className={`font-harvey-serif text-white text-[36px] sm:text-[52px] lg:text-[64px] font-normal leading-[1.05] tracking-tight transition-all duration-700 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
            >
              How We Protect Your Data
            </h1>

            <p
              className={`font-harvey-sans text-[#d4d4d8] text-[18px] sm:text-[22px] leading-relaxed font-light tracking-wide transition-all duration-700 delay-200 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              Your client information is privileged. We treat it that way
            </p>

            {/* Kinetic Text */}
            <div className="h-[50px] sm:h-[60px] overflow-hidden relative flex items-center justify-center">
              {kineticWords.map((word, index) => (
                <span
                  key={word}
                  className={`font-harvey-serif absolute text-[#06b6d4] text-[36px] sm:text-[48px] font-normal tracking-tight transition-all duration-500 ${
                    kineticIndex === index
                      ? 'opacity-100 translate-y-0 scale-100'
                      : 'opacity-0 translate-y-8 scale-95'
                  }`}
                  style={{
                    textShadow: '0 0 60px rgba(6, 182, 212, 0.6), 0 0 120px rgba(6, 182, 212, 0.3)'
                  }}
                >
                  {word}
                </span>
              ))}
            </div>

            {/* Feature List */}
            <div
              className={`grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-[600px] mx-auto transition-all duration-700 delay-400 ${
                animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 group"
                >
                  <span className="text-[#06b6d4] text-xl">✓</span>
                  <span className="font-harvey-sans text-white text-[15px] sm:text-[16px] font-normal tracking-wide">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
